<app-ui-kit-modal modalName="MAIN_MODAL" #modalTest>
  <h3 class="tw-text-center">Módulo de Pagos en Línea</h3>
  <p class="tw-text-center">Estimado socio, por el momento tenemos inconvenientes con el pago, estamos trabajando en el problema, gracias por su comprensión</p>
  <div class="tw-mt-2 tw-text-center">
    <button (click)="onAccept()" class="uk-button tw-mx-auto">Aceptar</button>
  </div>
</app-ui-kit-modal>
